import post from '@/api/post'

export default {
  getReports (params) {
    params = params || {limit: 100, page: 0}
    return post('get_reports', {
      rows: params.limit,
      page: params.page,
      sord: 'ASC',
      sidx: 'report_id'
    }).then(response => {
      response.data.data.rows = response.data.data.rows.map(item => ({
        id: parseInt(item.id),
        name: item.name,
        type: item.type,
        cell: item.cell
      }))
      return response.data.data
    })
  },
  downloadLastDayReport (type) {
    return post('get_last_report', {
      type: type
    }).then(response => {
      console.log(response)
      return response.data.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/services/objects/reports/index.js